import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import type { ClassItem } from '@/types/class'
import { classItem, requiredString } from '@/utils/zod'

const responseSchema = z.array(
  z.object({
    id: requiredString(),
    name: requiredString(),
    preferred_classes: z.array(classItem)
  })
)
export type Room = {
  id: string
  name: string
  classes: ClassItem[]
}

const parseResponse = (response: z.infer<typeof responseSchema>): Room[] =>
  response.map(item => ({
    id: item.id,
    name: item.name,
    classes: item.preferred_classes
      ? item.preferred_classes.map(classElement => ({
          id: classElement.id,
          name: classElement.display_name
        }))
      : []
  }))

const useRooms = () =>
  useQuery({
    queryKey: ['panelRoomsList'],
    staleTime: 60 * 100,
    queryFn: async () => {
      const response = await httpService.panel.panelRoomsList({
        page_size: 'max',
        fetchKeys: {
          id: true,
          name: true,
          preferred_classes: true
        }
      })

      const parsed = parseResponse(responseSchema.parse(response.results))

      return {
        list: parsed,
        options: parsed.map(group => ({
          label: group.name,
          value: group.id
        }))
      }
    }
  })

export default useRooms
